export const customColorSet = {
    '--sendbird-light-primary-500': '#E27162',
    '--sendbird-light-primary-400': '#879C64',
    '--sendbird-light-primary-300': '#788A58',
    '--sendbird-light-primary-200': '#F3B8B3',
    '--sendbird-light-primary-100': '#FFFFFF',
    '--sendbird-light-background-50': '#FCFAF2',
    '--sendbird-light-background-300': '#FCFAF2'
};

export const CONCIERGE_IMAGE = 'https://images-cdn.easyweddings.com.au/s3/prod-ew-image-global-v2/Live/ImageUploader/original-crop-83906bd7-3b34-5777-1121-3c1f217e116a-184f8b8c-83c6-4e71-8ec7-e05a1d94af94.jpg?quality=80&format=jpg&mode=crop&autorotate=true&width=200&height=200';

export const DEFAULT_CONCIERGE_NAME = 'Darcy';

export const CONCIERGE_CHANNEL_START_URL = 'channel_';

export const HUBSPOT_CONTACT_URL = 'https://app.hubspot.com/contacts/5944321/record/0-1/';